import styled from "styled-components";

export const ModalStyledForm = styled.form`
  padding: 1.8rem 2.2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  && div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2.2rem;
  }
`;
